const FeaturedContent = () => {
  const featuredContentImgConrainer = document.querySelectorAll(
    ".featured-content__image-container"
  );

  if (featuredContentImgConrainer) {
    featuredContentImgConrainer.forEach((item) => {
      const imgLength = item.getElementsByTagName("img").length;
      const pictureLength = item.getElementsByTagName("picture").length;

      if (imgLength === 2 || pictureLength === 2) {
        item.classList.add("featured-content__image-container__2-img");
      } else if (imgLength === 3 || pictureLength === 3) {
        item.classList.add("featured-content__image-container__3-img");
      }
    });
  }
};

export default FeaturedContent;
